import { AppSecondaryCommand } from 'owa-graph-schema';
import loc from 'owa-localize';
import { previewDisclaimerButton } from './AppTilePreviewCommand.locstring.json';

export const AppTilePreviewCommand: AppSecondaryCommand = {
    id: 'E463FF75-A019-4CE4-9FAD-2B13A04113CB',
    text: loc(previewDisclaimerButton) || 'Preview',
    command: {
        entity: {
            entityId: 'm365_previewdisclaimer',
            type: 'm365_previewdisclaimer',
            action: 'info',
        },
        command: {
            visibilityState: 'show',
            stateTransition: 'flush',
        },
    },
};
